"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const defaultNavItems = [{
    label: "Studio",
    href: "/studio"
  }, {
    label: "Projects",
    href: "/projects"
  }, {
    label: "Contact",
    href: "/contact"
  }];
  const items = menuItems && menuItems.length > 0 ? menuItems : defaultNavItems;
  return <ul className="flex flex-wrap items-center justify-center gap-x-2 text-[14px] md:text-[15px] font-normal leading-tight text-black">
      {items.map((item, index) => <React.Fragment key={item.id || item.label || index}>
          <li>
            <Link to={item.href || "#"} className="text-black transition-opacity duration-200 hover:opacity-70">
              {item.label}
            </Link>
          </li>
          {index < items.length - 1 && <li aria-hidden="true" className="select-none text-black">
              |
            </li>}
        </React.Fragment>)}
    </ul>;
}
export default function Header() {
  const shouldReduceMotion = useReducedMotion();
  return <motion.header id="header" initial={shouldReduceMotion ? {
    y: 0
  } : {
    y: "-100%"
  }} animate={{
    y: 0
  }} transition={{
    duration: shouldReduceMotion ? 0 : 0.7,
    delay: shouldReduceMotion ? 0 : 2.6,
    ease: [0.16, 1, 0.3, 1]
  }} className="sticky top-0 z-50 w-full overflow-visible bg-[#F5F4F2] py-7 md:py-9" style={{
    fontFamily: '"Libre Baskerville", "Times New Roman", Georgia, serif',
    color: "rgb(0, 0, 0)"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap');`}</style>
      <div className="mx-auto flex max-w-[1710px] flex-col items-center justify-center px-4 md:px-[105px]">
        <Link to="/" className="text-[13px] md:text-[14px] font-normal tracking-[0.38em] text-black uppercase transition-opacity duration-200 hover:opacity-70" style={{
        fontFamily: '"Libre Baskerville", "Times New Roman", Georgia, serif'
      }}>S&amp;l dESIGN</Link>
        <nav aria-label="Main Navigation" className="mt-2.5 flex items-center justify-center">
          <MenuProvider menu_id="16">
            <NavMenuContent />
          </MenuProvider>
        </nav>
      </div>
    </motion.header>;
}